import packageJson from "../../package.json";

export const BUILD_ID =
  process.env.REACT_APP_BUILD_ID || packageJson.version || "unknown";

export default BUILD_ID;
